import ajax from "../utils/request";
/**
 * AI女友管理 相关接口
 */
const aiFriendManageApi = {
  /******************************** AI角色表 *********************************** */
  getAiRoleList(params) {
    return ajax({
      url: '/ai_role/list',
      type: 'get',
      params: params
    });
  },
  createAiRole(params) {
    return ajax({
      url: '/ai_role/create',
      type: 'post',
      params: params
    });
  },
  delAiRole(params) {
    return ajax({
      url: '/ai_role/delete',
      type: 'post',
      params: params
    });
  },
  updateAiRole(params) {
    return ajax({
      url: '/ai_role/update',
      type: 'post',
      params: params
    });
  },
  syncAiList() {
    return ajax({
      url: '/ai_role/sync_list',
      type: 'get'
    })
  },
  /******************************** AI角色标签表 *********************************** */
  getAiRoleTagList(params) {
    return ajax({
      url: '/ai_tag/list',
      type: 'get',
      params: params
    });
  },
  createAiRoleTag(params) {
    return ajax({
      url: '/ai_tag/create',
      type: 'post',
      params: params
    });
  },
  delAiRoleTag(params) {
    return ajax({
      url: '/ai_tag/delete',
      type: 'post',
      params: params
    });
  },
  updateAiRoleTag(params) {
    return ajax({
      url: '/ai_tag/update',
      type: 'post',
      params: params
    });
  },
  /******************************** AI女友聊天会话 *********************************** */
  getAiDialogList(params) {
    return ajax({
      url: '/chat_session/list',
      type: 'get',
      params: params
    });
  },
  getAiDialogDetail(params) {
    return ajax({
      url: '/chat_session/details/list',
      type: 'get',
      params: params
    });
  },
  /******************************** AI女友聊天消息 *********************************** */
  getAiMessageList(params) {
    return ajax({
      url: '/chat_message/list',
      type: 'get',
      params: params
    });
  },
  /******************************** AI女友用户积分流水 *********************************** */
  getAiTransactionList(params) {
    return ajax({
      url: '/points_transaction/list',
      type: 'get',
      params: params
    });
  },
  /******************************** 产品配置相关接口 *********************************** */
  getProductConfigList(params) {
    return ajax({
      url: '/app_config/list',
      type: 'get',
      params: params
    });
  },
  createProductConfig(params) {
    return ajax({
      url: '/app_config/create',
      type: 'post',
      params: params
    });
  },
  delProductConfig(params) {
    return ajax({
      url: '/app_config/delete',
      type: 'post',
      params: params
    });
  },
  updateProductConfig(params) {
    return ajax({
      url: '/app_config/update',
      type: 'post',
      params: params
    });
  },
  /******************************** 模型成本价格管理 *********************************** */
  getCostList(params) {
    return ajax({
      url: '/aimodelprice/list',
      type: 'get',
      params: params
    });
  },
  createCost(params) {
    return ajax({
      url: '/aimodelprice/create',
      type: 'post',
      params: params
    });
  },
  delCost(params) {
    return ajax({
      url: '/aimodelprice/delete',
      type: 'post',
      params: params
    });
  },
  updateCost(params) {
    return ajax({
      url: '/aimodelprice/update',
      type: 'post',
      params: params
    });
  },
  /******************************** 每日汇总统计相关接口 *********************************** */
  getStat(params) {
    return ajax({
      url: '/app_stat/list',
      type: 'get',
      params: params
    });
  },
  getAppStat(params) {
    return ajax({
      url: '/app_stat/app/list',
      type: 'get',
      params: params
    });
  },
  getModelStat(params) {
    return ajax({
      url: '/app_stat/model/list',
      type: 'get',
      params: params
    });
  },
  getRoleStat(params) {
    return ajax({
      url: '/app_stat/role/list',
      type: 'get',
      params: params
    });
  },
  /******************************** 实时统计统计相关接口 *********************************** */
  getAppRealtime(params) {
    return ajax({
      url: '/app_stat/app/realtime',
      type: 'get',
      params: params
    });
  },
  getModelRealtime(params) {
    return ajax({
      url: '/app_stat/model/realtime',
      type: 'get',
      params: params
    });
  },
  getRoleRealtime(params) {
    return ajax({
      url: '/app_stat/role/realtime',
      type: 'get',
      params: params
    });
  },
  getAppRealtimeImage(params) {
    return ajax({
      url: '/app_stat/app/realtime/image',
      type: 'get',
      params: params
    });
  },
  getModelRealtimeImage(params) {
    return ajax({
      url: '/app_stat/model/realtime/image',
      type: 'get',
      params: params
    });
  },
  getRoleRealtimeImage(params) {
    return ajax({
      url: '/app_stat/role/realtime/image',
      type: 'get',
      params: params
    });
  },
};

export default aiFriendManageApi;
